import { TableHead } from '@material-ui/core';
import { ApplicationsTableProps } from '€lib/types/ApplicationsTableTypes';
import { StyledTableCell, StyledTableRow } from '../ApplicationsTableBody/styles';
import { useStyles } from './styles';

export default function ApplicationsTableHead({ headerGroups }: ApplicationsTableProps) {
    const classes = useStyles();
    return (
        <TableHead>
            {headerGroups.map(headerGroup => (
                <StyledTableRow key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                        <StyledTableCell
                            key={column.id}
                            className={classes.headCell}
                            {...column.getHeaderProps(column.getSortByToggleProps())}
                        >
                            {column.render('Header')}
                            <span>
                                {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                            </span>
                        </StyledTableCell>
                    ))}
                </StyledTableRow>
            ))}
        </TableHead>
    );
}
